import { render } from "./HelpPage.vue?vue&type=template&id=13a2c8a4"
const script = {}

import "./HelpPage.vue?vue&type=style&index=0&id=13a2c8a4&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__